"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bagnara-calabra": {
    "ad3baf8a": [{
      "hkey": "5c69ab38",
      "slug": "ceramida-pellegrina",
      "name": "Ceramida-Pellegrina",
      "primary": true,
      "skipSearch": false
    }],
    "ceramida": [{
      "hkey": "5c69ab38",
      "slug": "ceramida-pellegrina",
      "name": "Ceramida-Pellegrina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "82ecfca3": [{
      "hkey": "5c69ab38",
      "slug": "ceramida-pellegrina",
      "name": "Ceramida-Pellegrina",
      "primary": true,
      "skipSearch": false
    }],
    "pellegrina": [{
      "hkey": "5c69ab38",
      "slug": "ceramida-pellegrina",
      "name": "Ceramida-Pellegrina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bagnara-calabra"
    }]
  }
};
exports["default"] = _default;